import { useEffect, useState, useCallback } from "react";
import client from "@/lib/api";
import { ROADMAP_PHASES as FALLBACK } from "@/lib/roadmapData";

/**
 * Fetches the live roadmap from the backend. Falls back to the static
 * defaults if the API is unreachable (e.g. before backend boots / dev).
 *
 * Returns { phases, loading, error, refresh }.
 */
export default function useRoadmap() {
  const [phases, setPhases] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await client.get("/roadmap");
      if (Array.isArray(r.data) && r.data.length > 0) {
        setPhases(r.data);
      }
      setError(null);
    } catch (e) {
      setError(e);
      // keep fallback in state
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { phases, loading, error, refresh: load };
}
